import React from 'react';
import Container from 'components/Containers/Container';
import Card from 'components/Containers/Card';
import OnlineLetures from 'modules/SupportModule/components/OnlineLectures';

export default () => {
  return (
    <React.Fragment>
      <Container name='Bài giảng điện tử' parentName='Hỗ trợ giảng dạy'>
        <Card title='Danh sách bài giảng'>
          <OnlineLetures />
        </Card>
      </Container>
    </React.Fragment>
  );
};
